import BaseInputSelect from "./BaseInputSelect.vue";

export default BaseInputSelect;
